import {utils} from "../components/utils";
import {TypeShuffle} from "../libs/typeShuffle";

export function yourVotesInit() {

	let toggleVotazione = function (e) {
		e.preventDefault();

		let toggle = e.target;
		let transitionDuration = 600;

		if (toggle !== this && this.contains(toggle))
		{
			toggle = toggle.closest('.votazione__title');
		}

		if (toggle.classList.contains('animating'))
		{
			return;
		}
		else
		{
			toggle.classList.add('animating');
		}

		let content = utils.getNextSiblings(toggle);

		if (content !== null)
		{
			toggle.classList.toggle('active');

			content.forEach((element) => {
				utils.slideToggle(element, transitionDuration);
			});

			setTimeout(() => {
				toggle.classList.remove('animating');
			}, transitionDuration);
		}
	};

	const votazioneTitles = document.querySelectorAll('.votazione__title');

	if (votazioneTitles.length > 1)
	{
		votazioneTitles.forEach(el => {

			el.parentNode.classList.add('foldable');
			el.removeEventListener('click', toggleVotazione);
			el.addEventListener('click', toggleVotazione);

			// hide content after accordion toggle
			let content = utils.getNextSiblings(el);
			content.forEach((element) => {
				element.style.display = 'none';
			});
		});
	}
}